"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.statusBodyTemplate = exports.getStatusClass = exports.getStatusName = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const tag_1 = require("primereact/tag");
const getStatusName = (status) => {
    switch (status) {
        case true:
            return 'Online';
        case false:
            return 'Offline';
        default:
            return 'Unknown';
    }
};
exports.getStatusName = getStatusName;
const getStatusClass = (status) => {
    switch (status) {
        case true:
            return 'bg-green-500 text-white';
        case false:
            return 'bg-red-500 text-white';
        default:
            return 'bg-gray-500 text-white';
    }
};
exports.getStatusClass = getStatusClass;
const statusBodyTemplate = (status, statusName) => {
    const name = statusName ? 'Online' : 'Offline';
    return ((0, jsx_runtime_1.jsx)(tag_1.Tag, { value: name, className: `px-3 py-1 rounded-full ${(0, exports.getStatusClass)(status)}` }));
};
exports.statusBodyTemplate = statusBodyTemplate;
